import type { UIStringsOverride } from "../i18n-ui.ts";

/** Finnish (fi) UI strings. */
export const fi: UIStringsOverride = {
  actions: {
    addToCursor: "Lisää Cursoriin",
    addToVscode: "Lisää VS Codeen",
    askAI: "Kysy tekoälyltä tästä sivusta",
    connectMcp: "Yhdistä MCP:hen",
    copied: "Kopioitu!",
    copyClaudeCode: "Kopioi Claude Code -komento",
    copyCode: "Kopioi koodi",
    copyCodex: "Kopioi Codex-komento",
    copyMarkdown: "Kopioi Markdownina",
    copyServerUrl: "Kopioi palvelimen URL",
    edit: "Muokkaa GitHubissa",
    export: "Vie",
    exportEpub: "Vie EPUB-muotoon",
    exportPdf: "Vie PDF-muotoon",
    generating: "Luodaan…",
    openIn: "Avaa sovelluksessa {name}",
    openInChat: "Avaa keskustelussa",
    scrollToTop: "Takaisin ylös",
  },
  ask: {
    ai: "Tekoäly",
    clear: "Tyhjennä keskustelu",
    close: "Sulje",
    copy: "Kopioi keskustelu",
    empty: "Kysy kysymys dokumentaatiosta.",
    error: "Pahoittelut, jokin meni pieleen.",
    label: "Kysy kysymys",
    placeholder: "Kysy kysymys…",
    send: "Lähetä",
    tip: "Vinkki: Voit avata ja sulkea keskustelun näppäimillä",
    title: "Kysy tekoälyltä",
    you: "Sinä",
  },
  banner: { dismiss: "Sulje ilmoitus" },
  changelog: {
    description: "Tuotepäivitykset ja julkaisutiedot.",
    showReleases: "Näytä version {version} julkaisut",
    title: "Muutosloki",
  },
  content: { diagramError: "Tätä kaaviota ei voitu näyttää." },
  feedback: {
    no: "Ei",
    question: "Oliko tästä sivusta apua?",
    thanks: "Kiitos palautteestasi!",
    yes: "Kyllä",
  },
  languageSwitcher: { label: "Kieli", untranslated: "Ei käännetty" },
  nav: {
    back: "Takaisin",
    breadcrumb: "Murupolku",
    closeNavigation: "Sulje navigaatio",
    deprecated: "vanhentunut",
    featured: "Suositellut",
    githubRepository: "GitHub-repositorio",
    navigation: "Navigaatio",
    primary: "Ensisijainen",
    sections: "Osiot",
    toggleNavigation: "Näytä tai piilota navigaatio",
    toggleTheme: "Vaihda väriteemaa",
  },
  notFound: {
    description: "Etsimääsi sivua ei löytynyt.",
    home: "Takaisin etusivulle",
    title: "Sivua ei löytynyt",
  },
  page: {
    lastUpdated: "Viimeksi päivitetty",
    next: "Seuraava",
    pagination: "Sivutus",
    previous: "Edellinen",
    skipToContent: "Siirry sisältöön",
  },
  search: {
    all: "Kaikki",
    allLanguages: "Kaikki kielet",
    askAi: "Kysy tekoälyltä",
    askAiHint: "Saat välittömän vastauksen tekoälyltä",
    button: "Hae",
    devOnly: "Haku on käytettävissä tuotantokäännöksessä.",
    error: "Jokin meni pieleen. Yritä uudelleen.",
    label: "Hae dokumentaatiosta",
    navigate: "siirry",
    noResults: "Ei tuloksia.",
    open: "avaa",
    placeholder: "Hae dokumentaatiosta…",
    popular: "Suositut",
    preview: "esikatselu",
    results: "Tulokset",
  },
  toc: { title: "Tällä sivulla" },
};
